export default class SystemRight {
  constructor(obj) {
    this.administrator = obj.administrator;
    this.code = obj.code;
    this.company_id = obj.company_id;
    this.created_at = obj.created_at;
    this.description = obj.description;
    this.id = obj.id;
    this.manager = obj.manager;
    this.packer = obj.packer;
    this.planner = obj.planner;
    this.updated_at = obj.updated_at;
    this.worker = obj.worker;
  }
}
